<template>
  <section class="businessPage">
    <div class="businessPageHeader">
      <h1>{{title}}</h1>
      <h2>{{subTitle}}</h2>
    </div>
    <section class="businessPageStats">
      <div class="businessPageStatsGrid" v-for="(biz,index) in businesses" :key="index">
        <img :src="biz.icon" :alt="biz.title" />
        <h1>{{biz.title}}</h1>
        <h2>{{biz.subTitle}}</h2>
      </div>
    </section>
  </section>
</template>

<script>
import grid1 from '@/assets/hgMain/performance.svg';
import grid2 from '@/assets/hgMain/operations.svg';
import grid3 from '@/assets/hgMain/idea.svg';
import grid4 from '@/assets/hgMain/direction.svg';
import grid5 from '@/assets/hgMain/marketing.svg';
import grid6 from '@/assets/hgMain/globe.svg';
import grid7 from '@/assets/hgMain/product.svg';
import grid8 from '@/assets/hgMain/automation.svg';

export default {
  name: 'BusinessPage',
  data() {
    return {
      title: 'The Business Benefits of Artificial Intelligence',
      subTitle: 'The data below shows the the percentage of executives who site the following as business benefits of Artificial Intelligence. ',
      businesses: [
        {
          icon: grid1,
          title: '51%',
          subTitle: 'Enhance the features, functions and performance of our products'
        },
        {
          icon: grid2,
          title: '36%',
          subTitle: 'Optimize internal business operations'
        },
        {
          icon: grid3,
          title: '25%',
          subTitle: 'Capture and apply scarce knowledge where needed'
        },
        {
          icon: grid4,
          title: '35%',
          subTitle: 'Make better decisions'
        },
        {
          icon: grid5,
          title: '30%',
          subTitle: 'Optimize external processes like marketing and sales'
        },
        {
          icon: grid6,
          title: '25%',
          subTitle: 'Pursue new Markets'
        },
        {
          icon: grid7,
          title: '32%',
          subTitle: 'Create new products'
        },
        {
          icon: grid8,
          title: '36%',
          subTitle: 'Free up workers to be more creative by automating tasks'
        }
      ]
    }
  },
}
</script>

<style scoped>
@media (max-width: 600px) {
  .businessPage {
    position: relative;
    text-align: center;
  }
  .businessPageHeader > h1 {
    margin-top: 2rem;
    font-size: 4vw;
    margin-bottom: 0;
  }
  .businessPageHeader > h2 {
    font-size: 2.5vw;
    margin-bottom: 2rem;
    padding: 0 2rem;
  }
  .businessPageStats {
    position: relative;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 1rem 1rem;
    padding: 0 2rem;
    margin-bottom: 5rem;
  }
  .businessPageStatsGrid > img {
    height: auto;
    width: 40%;
  }
  .businessPageStatsGrid > h1 {
    font-size: 3vw;
    margin-bottom: 0;
  }
  .businessPageStatsGrid > h2 {
    font-size: 2vw;
    margin-bottom: 0;
  }
}
@media(min-width: 600px) {
  .businessPage {
    position: relative;
    text-align: center;
  }
  .businessPageHeader > h1 {
    font-size: 4vw;
    margin-bottom: 0;
  }
  .businessPageHeader > h2 {
    font-size: 2vw;
    margin-bottom: 2rem;
    padding: 0 10rem;
  }
  .businessPageStats {
    position: relative;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 2rem 3rem;
    padding: 0 5rem;
    margin-bottom: 5rem;
  }
  .businessPageStatsGrid > img {
    height: auto;
    width: 50%;
    background-position: center;
  }
  .businessPageStatsGrid > h1 {
    font-size: 3vw;
    margin-bottom: 0;
  }
  .businessPageStatsGrid > h2 {
    font-size: 1.5vw;
    margin-bottom: 0;
  }
}
</style>
